export default __webpack_public_path__ + "static/media/water.6b198dd5.png";